<template>
    <div class="field is-expanded">
        <div class="field">
            <div class="control is-expanded">
                <datetime
                    v-model="datetimeEmpty"
                    :min-datetime="minDate"
                    :placeholder="$t('Sessions.limit_date_hint')"
                    type="datetime"
                    class="input is-expanded"
                    @input="$emit('input', datetimeEmpty)"
                ></datetime>
            </div>
        </div>
    </div>
</template>

<script>
import { Datetime } from 'vue-datetime';
import _ from 'underscore';
export default {
    name: 'InputDatetime',
    components: {
        datetime: Datetime,
    },
    props: {
        minDate: {
            type: String,
            default: undefined,
        },
        value: {
            type: String,
            default: undefined,
        },
    },
    data() {
        return {
            datetimeEmpty: this.value,
        };
    },
};
</script>

<style>
@import '~vue-datetime/dist/vue-datetime.css';
.vdatetime input {
    border-width: 0;
    width: 100%;
}
</style>
